export const projectObj1 = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Do ShoutOuts in Public",
  headLine: "Encourage, support or spread your cause, your people, your thoughts, become a real world leader",
  subtitle: "Without making any noise, without waving any signs",
  img: require("../../images/shoutout.png"),
  alt: "shoutout",
};

export const projectObj2 = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Contribute to your community",
  headLine: "Inform, promote or advertise offers and services",
  subtitle: "Increase your local clients",

  img: require("../../images/community.png"),
  alt: "community",
};
export const projectObj3 = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Vivaram as your landing page",
  headLine: "Expose your social media links to real world people around you to expand your influence",
  subtitle: "Just by your presence.",

  img: require("../../images/landing.png"),
  alt: "landing",
};
export const projectObj4 = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Like, comment and share others' publications",
  headLine: "The power of social media brought into real world",
  subtitle: "Don't forget to subscribe to keep in touch with your influencers",
  img: require("../../images/likes.png"),
  alt: "likes",
};

export const projectObj5 = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Make new friends in the real world",
  headLine: "Know who you share your space with through their profile page, and make sure they know you",
  subtitle: "Keep track of people you met",
  img: require("../../images/couple.png"),
  alt: "couple",
};

export const projectObj6 = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Discover a new way of communication",
  headLine: "Speak to a new person in public by texting them! Have public talks through texting",
  subtitle: "Continue your conversation anytime anywhere.",
  img: require("../../images/emotional.png"),
  alt: "emotional",
};

export const joinObj1 = {
  id: "join",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Become a partner",
  headLine: "We need new partners to bring their vision, skills and support, please contact us",
  subtitle: "we are eager to know how you are planning to become a pillar of Vivaram",
  img: require("../../images/partner.png"),
  alt: "partner",
};
export const joinObj2 = {
  id: "join",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Have a career in Vivaram",
  headLine:
    "You are newbie looking for a project to practice your skills ? or an expert looking to support new startups as a freelancer ?",
  subtitle: "your motivation is all we expect",
  img: require("../../images/career.png"),
  alt: "career",
};

export const joinObj3 = {
  id: "join",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,

  topLine: "Become a donator",
  headLine: "We rely on donations from our donators and partners. Thanks to you, we are able to bring this project to life",
  subtitle: "You will have your print in our edifice, please check our donators page",
  img: require("../../images/donators.png"),
  alt: "donators",
};
export const joinObj4 = {
  id: "join",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Become a Beta-Tester",
  headLine: "Sign up for our newsletter and we'll keep you informed about our progress",
  subtitle:
    "We will not use your email address for anything else, for more information check Privacy policy",
  img: require("../../images/beta.png"),
  alt: "beta",
};

//-------------------french-------------------------

export const projectObj1fr = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Faites des dédicaces en public",
  headLine: "Encouragez, soutenez ou diffusez vos causes et vos pensées, devenez un véritable leader",
  subtitle: "Sans faire de bruit, sans agiter un signe",
  img: require("../../images/shoutout.png"),
  alt: "shoutout",
};

export const projectObj2fr = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Contribuez à votre communauté",
  headLine: "Informez et faites connaître des offres et des services",
  subtitle: "Développez votre clientèle locale",

  img: require("../../images/community.png"),
  alt: "community",
};
export const projectObj3fr = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Vivaram comme votre page vitrine",
  headLine: "Exposez vos liens des réseaux sociaux autour de vous, pour augmenter votre influence",
  subtitle: "Votre présence suffit",

  img: require("../../images/landing.png"),
  alt: "landing",
};
export const projectObj4fr = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Aimez, commentez et partagez les publications des autres",
  headLine: "Le pouvoir des médias sociaux introduit dans le monde réel",
  subtitle: "N'oubliez pas de vous abonner pour rester en contact avec vos influenceurs",
  img: require("../../images/likes.png"),
  alt: "likes",
};

export const projectObj5fr = {
  id: "project",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Faites-vous de nouveaux amis dans le monde réel",
  headLine: "Sachez avec qui vous partagez votre espace via leur page de profil et assurez-vous qu'ils vous connaissent",
  subtitle: "Gardez une trace des personnes que vous avez rencontrées",
  img: require("../../images/couple.png"),
  alt: "couple",
};

export const projectObj6fr = {
  id: "project",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Découvrez un nouveau moyen de communication",
  headLine: "Parlez à une nouvelle personne en public en lui envoyant des textos ! ",
  subtitle: "Continuez votre conversation n'importe quand, n'importe où",
  img: require("../../images/emotional.png"),
  alt: "emotional",
};

export const joinObj1fr = {
  id: "join",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,
  topLine: "Devenez un associé",
  headLine: "Nous avons besoin d'associés pour apporter leurs visions, leurs compétences et leurs soutiens, veuillez nous contacter",
  subtitle: "Nous sommes impatients de connaître comment vous envisagez de devenir un pillier de Vivaram",
  img: require("../../images/partner.png"),
  alt: "partner",
};
export const joinObj2fr = {
  id: "join",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Faire carrière dans Vivaram",
  headLine:
  "Vous êtes un débutant à la recherche d'un projet pour exercer ? ou un expert à la recherche d'un nouveau projet en freelance ?",
  subtitle: "votre motivation est tout ce que nous attendons.",
  img: require("../../images/career.png"),
  alt: "career",
};

export const joinObj3fr = {
  id: "join",
  lightBg: true,
  lightText: false,
  lightTextSub: false,
  imgStart: false,

  topLine: "Devenez donateur",
  headLine: "Nous comptons sur les dons de nos donateurs et associés. c'est grâce à vous que nous pouvons donner vie à ce projet",
  subtitle: "Vous aurez votre empreinte dans notre édifice, merci de consulter notre page donateurs..",
  img: require("../../images/donators.png"),
  alt: "donators",
};
export const joinObj4fr = {
  id: "join",
  lightBg: false,
  lightText: true,
  lightTextSub: true,
  imgStart: true,
  topLine: "Devenez Beta-Testeur",
  headLine : "Inscrivez-vous à notre newsletter et nous vous tiendrons au courant de nos progrès",
  subtitle:
  "Nous n'utiliserons pas votre adresse e-mail pour autre chose. Pour plus d'informations consultez notre Déclaration de confidentialité",
  img: require("../../images/beta.png"),
  alt: "beta",
};
